import { useMediaQuery } from "@mui/material";

export const SIDEBAR_WIDTH_EXPANDED = 220;
export const SIDEBAR_WIDTH_COLLAPSED = 60;
// export const isMobile = useMediaQuery('(max-width:768px)');
